import buildKnotty from '@homeaway/knotty';

let knottyLogger;

export default class ClientLogger {
    static initialize(options) {
        knottyLogger = buildKnotty(options);
    }

    static logInfo(msg) {
        return knottyLogger.logInfo(msg);
    }

    static logError(msg) {
        return knottyLogger.logError(msg);
    }

    static logException(msg) {
        return knottyLogger.logException(msg);
    }
}
